import type { ComponentProps, ReactNode } from 'react'
import { cn } from '../lib/cn'
import { useFieldControlProps } from '../lib/field-context'
import { buttonStyles } from './button'
export function FileInput({
  children,
  className,
  onChange,
  ...props
}: Omit<ComponentProps<'input'>, 'type' | 'children' | 'value' | 'defaultValue'> & {
  children: ReactNode
}) {
  const field = useFieldControlProps(props)
  return (
    <label
      className={cn(
        buttonStyles({ appearance: 'outline', tone: 'neutral' }),
        'relative cursor-pointer has-focus-visible:outline-2 has-focus-visible:outline-offset-2 has-focus-visible:outline-ring has-disabled:cursor-not-allowed has-disabled:opacity-50',
        className,
      )}
    >
      <input
        {...props}
        {...field}
        type="file"
        data-slot="file-input"
        className="sr-only"
        onChange={(event) => {
          onChange?.(event)
          event.target.value = ''
        }}
      />
      {children}
    </label>
  )
}
